module.exports = __webpack_public_path__ + "img/icon-ticket-sport.4680242a.svg";